export default "__VITE_ASSET__CkQKQn4W__"